export const appRoles = {
  user: 'infocenter.user',
  superuser: 'infocenter.superuser',
  internal: 'infocenter.internal',
};
export const acceptedRoles: string[] = [
  appRoles.user,
  appRoles.superuser,
  appRoles.internal,
];
